import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["norwegian-method"]!;

export function Body() {
  return (
    <>
      <p>
        The Norwegian method is one of the most talked-about ways to train for distance running.
        A 2023 review describes what it actually involves, and it looks quite different from the
        version that often circulates among recreational runners.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from Spain, the United States and Norway, including the former Norwegian
        runner Marius Bakken, described the training model used by some world-class middle- and
        long-distance runners, and reviewed the possible reasons it works.
      </p>

      <h2>What they found</h2>
      <p>
        The model consists of three to four threshold interval sessions and one session at
        maximal oxygen uptake intensity each week. Easy running brings the total up to 150 to
        180 km a week.
      </p>
      <p>
        In the threshold sessions, pace is controlled by blood lactate, typically between 2 and
        4.5 mmol/L, measured every one to three repetitions. The point is to stay controlled. The
        authors suggest that running just below a hard effort allows faster recovery between
        sessions, so more of this work can be done each week.
      </p>

      <h2>What it means for you</h2>
      <p>
        The idea you can use is control. Threshold intervals should feel hard but manageable,
        and the last repetition should be as good as the first. Many recreational runners run
        their "threshold" sessions too fast, which turns them into something closer to a race.
      </p>
      <p>
        The full model is built for runners who train well over 100 km a week and measure
        lactate during their sessions. Three to four threshold sessions a week on top of a normal
        recreational volume would be a big jump in hard training. For most runners, one or two
        controlled threshold sessions a week alongside easy running is a more realistic way to
        use the idea.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The review describes a training model and possible mechanisms. It is not a trial that
        compares the model with other ways of training, and it is based on elite runners.
      </p>

      <h2>How we use it</h2>
      <p>
        Threshold sessions in PX7 Training have a target and a range for each work period, so
        they stay controlled from the first repetition to the last. How many hard sessions you
        get depends on your training, your goal and how you recover.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Casado et al. (2023), Does lactate-guided threshold interval training within a
          high-volume low-intensity approach represent the "next step" in the evolution of
          distance running training?{" "}
          <a href="https://doi.org/10.3390/ijerph20053782">International Journal of Environmental Research and Public Health</a>.
        </li>
      </ul>
    </>
  );
}
